module.exports = __webpack_public_path__ + "img/9788997980123.a96c3c2b.jpg";